export const SET_LOADING_STATUS = "SET_LOADING_STATUS"
export const INCREMENT_ERROR_COUNT = "INCREMENT_ERROR_COUNT"
export const CLEAR_ERROR_COUNT = "CLEAR_ERROR_COUNT"
export const SET_AJAX_RESPONSE = "SET_AJAX_RESPONSE"
export const CLEAR_AJAX_RESPONSE = "CLEAR_AJAX_RESPONSE"
export const TOGGLE_MENU = "TOGGLE_MENU"


// WEBPACK FOOTER //
// ./src/actionTypes/app.js